import React from 'react';

import  ArtLeaf2024  from 'views/ArtLeaf2024';

const DesktopAppPage = () => {
  return <ArtLeaf2024 />;
};

export default DesktopAppPage;
